import { BrowserAdapter } from './adapter.mjs';

const settings = {
  ADAPTER: BrowserAdapter,
  RESOLUTION: 1,
  RENDER_OPTIONS: {
    view: null,
    antialias: false,
    autoDensity: false,
    backgroundColor: 0,
    backgroundAlpha: 1,
    premultipliedAlpha: true,
    clearBeforeRender: true,
    preserveDrawingBuffer: false,
    width: 800,
    height: 600,
    legacy: false,
    hello: false
  },
  CREATE_IMAGE_BITMAP: false,
  ROUND_PIXELS: false
};

export { settings };
//# sourceMappingURL=settings.mjs.map
